import TermsUpdate from './TermsUpdate';

export default TermsUpdate;